module.exports = __webpack_public_path__ + "img/angle-double-up.68db5302.svg";